// extracted by mini-css-extract-plugin
export default {"obs-upload":"ObsImageUpload_obs-upload__WZ4qD","upload-area":"ObsImageUpload_upload-area__nfi--"};